export enum SalesPersonEnum {
    BALAJIPANDURANGAN = 'BALAJI PANDURANGAN',
    JAGANRAMALINGAM = 'JAGAN RAMALINGAM',
    JYOTIPUSHKARNA = 'JYOTI PUSHKARNA',
    KARTHIKEYANVENKATESH = 'KARTHIKEYAN VENKATESH',
    KUMUDMUNJAL = 'KUMUD MUNJAL',
    RAGHAVENDRAKALOOR = 'RAGHAVENDRA KALOOR',
    RAKESHSHARMA = 'RAKESH SHARMA',
    RAVINDRANATHTAGORE = 'RAVINDRANATH TAGORE',
    RITESHKUMAR = 'RITESH KUMAR',
    SANGEETARAZDAN = 'SANGEETA RAZDAN',
    SANJIVTERWADKAR = 'SANJIV TERWADKAR',
    SENTHILSUBBAIYAN = 'SENTHIL SUBBAIYAN',
    SURESHSELVAMATHESON = 'SURESH SELVAMATHESON',
    VADIVELMURUGAN = 'VADIVEL MURUGAN',
    VINESHKRISHNAN = 'VINESH KRISHNAN',
    YOGESHSOOD = 'YOGESH SOOD',
}
